module.exports = __webpack_public_path__ + "img/couples-032.34b08d92.jpg";